export function sortCollection(collection = [], field = null, ascending = true) {

    if (collection && field) {
        collection.sort((x, y) => {

			let a
			let b
        
        	if (typeof field === 'function') {
        	
        		a = field(x)
        		b = field(y)
        		
        	} else {
        	
				a = x
				b = y
			
				field.split('.').forEach(f => {
					a = a[f]
					b = b[f]
				})
			
				a = typeof a === 'string' ? a.toLowerCase() : a
				b = typeof b === 'string' ? b.toLowerCase() : b                
	
        	}

            if (a < b) {
                return ascending ? -1 : 1
            } else if (a > b) {
                return ascending ? 1 : -1
            } else {
                return 0
            }
            
        })
    } 
    
    return collection       
}

export function sortArray(arraData = []) {
    if (arraData?.length > 0) {
        arraData.sort((x, y) => {
            if (x < y) {
                return -1
            } else if (x > y) {
                return 1
            }
        })
    }    
}

export function sortResults(items = [], field, sortOrder) {
    return items?.sort((a, b) =>
        a[field] < b[field]
            ? sortOrder?.toLowerCase() === 'asc' ? -1 : 1
            : a[field] > b[field]
            ? sortOrder?.toLowerCase() === 'asc' ? 1 : -1
            : 0,
    ) 
}

export function sortCollectionWithArray(items = [], field, sortOrder) {
    return items?.sort((a, b) =>
        a[field]?.length < b[field]?.length
            ? sortOrder?.toLowerCase() === 'asc' ? -1 : 1
            : a[field]?.length > b[field]?.length
            ? sortOrder?.toLowerCase() === 'asc' ? 1 : -1
            : 0,
    ) 
}